import { ColorGroupDTO } from '@/api/dto/ColorGroupDTO';
import { CrudEndpoint } from '@/api/common/CrudEndpoint';

export class ColorGroupCRUD extends CrudEndpoint<ColorGroupDTO> {
  constructor() {
    super('colorgroup');
  }
}
